import { CourseType, ICheckboxGroup, IFacet, IOption } from "@into-discovery/browsewebshared";

export function mapFacetsToFilters(
  allFacets: IFacet[],
  selectedFacets: IFacet[],
  showIcasLabel?: boolean
): ICheckboxGroup[] {
  const filters = allFacets.map(
    (facet): ICheckboxGroup => ({
      name: facet.title,
      id: facet.id,
      options: facet.values.map(
        (facetTerm): IOption => ({
          text: facetTerm === `SupportedDirectEntry` ? CourseType.Others : facetTerm,
          name: facetTerm,
          id: facetTerm,
          parentName: facet.id,
          hideOption: facetTerm === CourseType.ICAS ? !showIcasLabel : false,
          selected: !!selectedFacets.find((selectedFacet) => selectedFacet.values.includes(`"${facetTerm}"`)&& selectedFacet.id === facet.id)
        })
      )
    })
  );
  return filters;
}
